module.exports = __webpack_public_path__ + "static/media/reports-color.d047f96d.png";